<template>
    <div class="flex flex-col">
        <div class="flex w-full ml-8 justify-between">
            <div class="flex w-1/2 items-start">
                <div class="flex flex-col w-1/3">
                    <label class="font-bold text-xs select-none mb-2" for="last_name">Datum / Raspon</label>
                    <vue-ctk-date-time-picker
                        class="form-control reports"
                        :class="{ _error: validationErrors.noDate }"
                        id="picked_date"
                        v-model="pickedDate"
                        label="Odaberite datum"
                        locale="hr"
                        format="YYYY-MM-DD"
                        formatted="DD.MM.YYYY."
                        :only-date="true"
                        :range="true"
                        :noShortcuts="true"
                    ></vue-ctk-date-time-picker>
                    <span
                        class="error-message"
                        v-if="validationErrors.noDate"
                        v-text="validationErrors.noDate[0]"
                    ></span>
                </div>
                <div class="w-1/3 mx-4">
                    <div class="form-group">
                        <label for="project">Radni nalog</label>
                        <v-select
                            class="form-select"
                            id="project"
                            :options="projectList"
                            :clearable="false"
                            :multiple="true"
                            label="name"
                            :closeOnSelect="false"
                        >

                            <template #selected-option-container="{ id }">
                                <div class="hidden">{{ id }}</div>
                            </template>
                            <template #option="{ name, id }">
                                <div class="form-group no-margin form-checkbox items-start justify-center w-full">
                                    <input
                                        class=""
                                        type="checkbox"
                                        :name="'project-' + id"
                                        :id="'project-' + id"
                                        v-model="projectItems[projectItems.findIndex(project => project.id == id)].selected"
                                    />
                                    <label class="w-full my-2 px-2 font" :for="'project-' + id">{{ name }}</label>
                                </div>
                            </template>
                        </v-select>
                    </div>
                </div>
            </div>
            <div class="ml-auto mt-6 mr-8 flex">
                <button class="btn primary" @click="showDataForDate">
                    Prikaži
                </button>
                <a
                    :href="route('vehicles.export')"
                    class="mx-2 btn secondary export flex items-center"
                >Izvoz svih vozila</a>
            </div>
        </div>
        <div v-if="showCard" class="mx-8 flex flex-col mt-6">
            <div class="flex flex-col">
                <h1 class="font-heading font-bold text-xl" v-if="pickedDate.end">Izvještaj za radoblje {{ pickedDate.start }} do {{ pickedDate.end }}</h1>
                <h1 class="font-heading font-bold text-xl" v-else>Izvještaj za datum {{ pickedDate.start }}</h1>
                <div
                    v-for="(record, index) in vehicleData" :key="'vehicle-' + index"
                    class="flex flex-col w-1/2 my-4"
                >
                    <div class="font-heading text-lg font-bold">
                        <h2>Projekt: {{ record.project }}</h2>
                    </div>
                    <div class="flex flex-col">
                        <div
                            class="flex justify-between font-semibold my-4"
                        >
                            <span>Vozilo:</span>
                            <span>Registracijska oznaka:</span>
                            <span>Datum korištenja:</span>
                        </div>
                        <div
                            v-for="(vehicle, vIndex) in record.vehicles"
                            :key="'project-' + index + '-vehicle-' + vIndex"
                            class="flex justify-between my-2"
                        >
                            <span>{{ vehicle.name }}</span>
                            <span>{{ vehicle.registration }}</span>
                            <span>{{ vehicle.date }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <response
            v-if="showResponse"
            :data="responseData"
        ></response>
    </div>
</template>

<script>
import Modal from './Modal'
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
import Response from './Response'

export default {
    components: {
        VueCtkDateTimePicker,
        Modal,
        vSelect,
        Response,
    },

    props: {
        projectList: {
            type: Array,
            default: () => ([]),
            required: true,
        },
    },

    data() {
        return {
            pickedDate: "",
            validationErrors: {},
            redirectMessage: "",
            showCard: false,
            showEditModal: false,
            workHours: [],
            showResponse: false,
            responseData: {},
            projectItems: [],
            vehicleData: [],
        };
    },

    created() {
        _.forEach(this.projectList, (project, index) => {
            project.selected = false
            this.projectItems.push(project)
        })

        _.forEach(this.usersList, (user, index) => {
            user.selected = false
            this.usersItems.push(user)
        })
    },

    methods: {
        toggleResponse() {
            this.showResponse = true
            setTimeout(() => {
                this.showResponse = false
            }, 2000);
        },

        showDataForDate() {
            if (!this.pickedDate.start) {
                this.validationErrors = {
                    noDate: ["Odaberite barem jedan datum"]
                };
            } else {
                this.fetchData();
            }
        },

        fetchData() {
            let formData = new FormData();
            let endpoint = "";

            _.forEach(this.projectItems, (project, index) => {
                if (project.selected) {
                    formData.append('projects[' + index + ']', project.id)
                }
            })

            formData.append('start_date', this.pickedDate.start)
            formData.append('end_date', this.pickedDate.end)

            endpoint = route("reports.vehicles");

            // Send the formData to user controller store/update function depending on endpoint
            axios.post(endpoint, formData)
                .then(response => {
                    if (response.status === 200) {

                        this.vehicleData = response.data;
                        if (this.vehicleData.length) {
                            this.showCard = true;
                        } else {
                            // TODO: Response no data
                        }
                    }
                })
                .catch(error => {
                    if (typeof error.response !== "undefined")
                        this.validationErrors = error.response.data.errors;

                    console.error(error);
                });
        },
    }
};
</script>
